import i18n from "i18next";
import {useState} from "react";
import {OverlayTrigger, Popover} from "react-bootstrap";

export default function BillingFrequency({state, dispatch}) {
    const [openBillingMenu, setOpenBillingMenu] = useState(false);

    return (
        <div>
            {state.toggleValue === "monthly" ?
                <div className="d-flex justify-content-end billing-frequency no-options-frequency">
                        {state.billingFrequency === "monthly" ?
                            i18n.t("buy-flow.billed-monthly") : i18n.t("buy-flow.billed-yearly")}
                </div> :
                <div className={`d-flex justify-content-end billing-frequency${openBillingMenu ? " open-menu" : ""}`}
                     onClick={() => setOpenBillingMenu(true)}
                >
                    <OverlayTrigger
                        trigger="click"
                        placement="bottom"
                        onToggle={() => setOpenBillingMenu(false)}
                        show={openBillingMenu}
                        rootClose
                        overlay={<Popover id={`billing-frequency-popover`}>
                            <Popover.Body>
                                <div onClick={e => {
                                    e.stopPropagation();
                                    dispatch({ type: "billingFrequency", payload: { billingFrequency: "monthly" }});
                                    setOpenBillingMenu(false);
                                }}>{i18n.t("buy-flow.billed-monthly")}
                                    {state.billingFrequency === "monthly" ? <i className="far fa-check"/> : null}
                                </div>
                                <div onClick={e => {
                                    e.stopPropagation();
                                    dispatch({ type: "billingFrequency", payload: { billingFrequency: "yearly" }});
                                    setOpenBillingMenu(false);
                                }}>{i18n.t("buy-flow.billed-yearly")}
                                    {state.billingFrequency === "yearly" ? <i className="far fa-check"/> : null}
                                </div>
                            </Popover.Body>
                        </Popover>}
                    >
                        <div>
                            {state.billingFrequency === "monthly" ?
                                i18n.t("buy-flow.billed-monthly") : i18n.t("buy-flow.billed-yearly")}
                            <i className="far fa-chevron-down"/>
                        </div>
                    </OverlayTrigger>
                </div>
                }
        </div>

    )
}
